module.exports = __webpack_public_path__ + "static/media/githubLogo.0918d786.png";